<footer class="bg-gray-900 text-gray-300 mt-16">
  <div class="max-w-7xl mx-auto px-4 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
    <!-- Marca + "Sobre Nosotros" + redes -->
    <div class="col-span-2 md:col-span-1 space-y-3">
      <div class="flex items-center gap-2">
        @if (configService.branding().logoUrl) {
          <img [src]="configService.branding().logoUrl" alt="" class="h-8 w-auto object-contain max-w-[120px] rounded bg-white p-0.5" />
        } @else {
          <div class="w-8 h-8 rounded-lg bg-primary-600 flex items-center justify-center text-white font-bold text-sm uppercase" aria-hidden="true">
            {{ (configService.branding().siteName || 'F').charAt(0) }}
          </div>
        }
        <span class="font-bold text-white">{{ configService.branding().siteName || 'FAISEN' }}</span>
      </div>
      <p class="text-sm text-gray-400 leading-relaxed">{{ aboutText() }}</p>

      @if (socials().length) {
        <ul class="flex items-center gap-2 pt-1" aria-label="Redes sociales">
          @for (s of socials(); track s.key) {
            <li>
              <a
                [href]="s.href"
                target="_blank"
                rel="noopener"
                class="w-9 h-9 rounded-full bg-gray-800 hover:bg-primary-600 text-gray-300 hover:text-white flex items-center justify-center transition-colors"
                [attr.aria-label]="s.label + ' (abre en otra pestaña)'"
              >
                <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  @switch (s.key) {
                    @case ('instagram') {
                      <rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" />
                    }
                    @case ('facebook') {
                      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                    }
                    @default {
                      <path d="M16 3a5 5 0 0 0 5 5v4a9 9 0 0 1-5-1.5V16a6 6 0 1 1-6-6v4a2 2 0 1 0 2 2V3z" />
                    }
                  }
                </svg>
              </a>
            </li>
          }
        </ul>
      }
    </div>

    <!-- Tienda: mismas reglas que el header -->
    <div>
      <h4 class="font-semibold text-white text-sm mb-3">Tienda</h4>
      <ul class="space-y-2 text-sm">
        @if (nav.hasType('PRODUCT')) {
          <li><a [routerLink]="['/' + configService.currentSlug() + '/productos']" class="hover:text-white">Productos</a></li>
        }
        @if (nav.hasType('SERVICE')) {
          <li><a [routerLink]="['/' + configService.currentSlug() + '/productos']" [queryParams]="{ tipo: 'SERVICE' }" class="hover:text-white">Servicios</a></li>
        }
        @if (nav.hasType('KIT')) {
          <li><a [routerLink]="['/' + configService.currentSlug() + '/productos']" [queryParams]="{ tipo: 'KIT' }" class="hover:text-white">Combos & Kits</a></li>
        }
        @if (nav.hasCategories()) {
          <li><a [routerLink]="['/' + configService.currentSlug() + '/categorias']" class="hover:text-white">Categorías</a></li>
        }
        <li><a [routerLink]="['/' + configService.currentSlug() + '/favoritos']" class="hover:text-white">Favoritos</a></li>
      </ul>
    </div>

    <!-- Cuenta: según la sesión -->
    <div>
      <h4 class="font-semibold text-white text-sm mb-3">Mi cuenta</h4>
      <ul class="space-y-2 text-sm">
        <!-- Los pedidos no necesitan sesión: van por código + token guardados al comprar. -->
        <li><a [routerLink]="['/' + configService.currentSlug() + '/pedidos']" class="hover:text-white">Mis pedidos</a></li>
        @if (auth.isAuthenticated()) {
          <li><a routerLink="/cuenta" class="hover:text-white">Mi cuenta</a></li>
        } @else {
          <li><a routerLink="/auth/login" [queryParams]="{ returnTo: currentUrl() }" class="hover:text-white">Iniciar sesión</a></li>
          <li><a routerLink="/auth/register" [queryParams]="{ returnTo: currentUrl() }" class="hover:text-white">Crear cuenta</a></li>
        }
        <li><a [routerLink]="['/' + configService.currentSlug() + '/carrito']" class="hover:text-white">Carrito</a></li>
      </ul>
    </div>

    <!-- Contacto: solo lo configurado (sin datos, la columna no aparece) -->
    @if (hasContact()) {
      <div>
        <h4 class="font-semibold text-white text-sm mb-3">Contacto</h4>
        <ul class="space-y-3 text-sm">
          @if (whatsapp(); as wa) {
            <li>
              <a [href]="wa.href" target="_blank" rel="noopener" class="inline-flex items-center gap-2 hover:text-white" aria-label="Escribir por WhatsApp (abre en otra pestaña)">
                <svg class="w-4 h-4 text-emerald-400 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M21 11.5a8.4 8.4 0 0 1-12.4 7.4L3 21l2.1-5.4A8.4 8.4 0 1 1 21 11.5z" /></svg>
                {{ wa.label }}
              </a>
            </li>
          }
          @if (address(); as addr) {
            <li class="flex items-start gap-2 text-gray-400">
              <svg class="w-4 h-4 mt-0.5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 22s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12z" /><circle cx="12" cy="10" r="2.5" /></svg>
              <span>{{ addr }}</span>
            </li>
          }
        </ul>
      </div>
    }
  </div>

  <div class="border-t border-gray-800 py-4 text-center text-xs text-gray-500">
    © {{ year }} {{ configService.branding().siteName || 'FAISEN' }}. Todos los derechos reservados.
  </div>
</footer>
